import { render, staticRenderFns } from "./RegistrationComponent.vue?vue&type=template&id=60f831a9&"
import script from "./RegistrationComponent.vue?vue&type=script&lang=js&"
export * from "./RegistrationComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports